import React from "react";
import { Settings2 } from "lucide-react";
import { PAGE_PRESETS, PrintSize } from "../lib/printSize";

const clamp = (v: string) => Math.min(60, Math.max(1, parseFloat(v) || 1));

export default function PrintSizeControl({ value, onChange }: { value: PrintSize; onChange: (s: PrintSize) => void }) {
  const isCustom = value.key === "custom";

  const pick = (key: string) => {
    const p = PAGE_PRESETS.find((x) => x.key === key)!;
    if (p.custom) {
      const prev = value.key === "custom";
      onChange({ key: "custom", wIn: prev ? value.wIn : 8.5, hIn: prev ? value.hIn : 11 });
    } else {
      onChange({ key: p.key, wIn: p.wIn, hIn: p.hIn });
    }
  };

  return (
    <div className="no-print flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-white px-3 py-2" data-testid="print-size-control">
      <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-700"><Settings2 size={15} /> প্রিন্ট পেজ সাইজ</span>
      <select
        className="inp inp-sm"
        style={{ width: "auto" }}
        value={value.key}
        onChange={(e) => pick(e.target.value)}
        data-testid="print-size-select"
      >
        {PAGE_PRESETS.map((p) => <option key={p.key} value={p.key}>{p.label}</option>)}
      </select>
      {isCustom && (
        <span className="inline-flex items-center gap-1.5">
          <input
            className="inp inp-sm w-[72px] num" type="number" step="0.1" min="1"
            value={value.wIn}
            onChange={(e) => onChange({ ...value, wIn: clamp(e.target.value) })}
            data-testid="print-size-width-input" aria-label="প্রস্থ (ইঞ্চি)"
          />
          <span className="text-slate-400 text-sm">×</span>
          <input
            className="inp inp-sm w-[72px] num" type="number" step="0.1" min="1"
            value={value.hIn}
            onChange={(e) => onChange({ ...value, hIn: clamp(e.target.value) })}
            data-testid="print-size-height-input" aria-label="উচ্চতা (ইঞ্চি)"
          />
          <span className="text-slate-500 text-sm">ইঞ্চি (প্রস্থ × উচ্চতা)</span>
        </span>
      )}
    </div>
  );
}
